import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "google-sign-in"
  static values = { clientId: String, url: String, trackUrl: String, companyId: String, errorMessage: String }
  static targets = ["error"]

  connect() {
    super.connect()
    this.send("connect", { clientId: this.clientIdValue })
  }

  signIn(event) {
    if (!this.enabled) return

    event.preventDefault()
    this.#hideError()

    this.send("requestSignIn", {}, (message) => {
      if (message.data.error) {
        // Bridge-level failure (cancel, no account on device, network) never
        // reaches the server, so beacon it here. "cancelled" is a user choice,
        // not an error to surface — track it but don't show the error message.
        this.#trackFailure(message.data.error)
        if (message.data.error !== "cancelled") this.#showError()
        return
      }

      this.#submitToken(message.data.idToken)
    })
  }

  async #submitToken(idToken) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({
          id_token: idToken,
          company_id: this.companyIdValue,
        }),
      })

      const data = await response.json()

      if (data.success) {
        window.location.href = data.redirect_url
      } else {
        // The server reached a failure branch and already tracked it; just show.
        this.#showError()
      }
    } catch (error) {
      this.#trackFailure("network_error")
      this.#showError()
    }
  }

  // Beacon a native sign-in failure that the server never saw, so the native
  // funnel drop-off (sheet cancels, missing accounts, network) is measurable.
  #trackFailure(reason) {
    if (!this.hasTrackUrlValue) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.trackUrlValue, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": csrfToken },
      body: JSON.stringify({ method: "google", reason, company_id: this.companyIdValue }),
      keepalive: true,
    }).catch(() => {})
  }

  #showError() {
    if (this.hasErrorTarget) this.errorTarget.classList.remove("hidden")
  }

  #hideError() {
    if (this.hasErrorTarget) this.errorTarget.classList.add("hidden")
  }
}
